<template>
  <div class="home">
    <button>首页</button>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
  	return {
  		userType: window.localStorage.getItem("userType")
  	}
  },
  mounted() {
  	this.getInfo();
  },
  methods:{
	  getInfo(){
		  const that = this
		  this.$axios({
			  url: '/jfapi/userinfo/' + that.userType,
		  }).then(function(res){
			  // console.log(res.data);
			  // console.log(that.userType)
		  });
	  }
  }
};
</script>

<style lang="scss" scoped>
.home {
  // background-color: #f0f0f0;
  height: 100%;
  box-sizing: border-box;
  padding-top: 20px;
}
</style>
